export default __webpack_public_path__ + "static/media/pfp4.b4e70662.png";